module.exports = __webpack_public_path__ + "img/advantage-group.9462905d.png";